<template>
  <div class="originalVideo div-layout tab-resetStyle">
    <!-- <router-view /> -->
    <el-tabs v-model="activeName">
      <el-tab-pane label="视频分类" name="type">
        <video-type v-if="activeName==='type'" />
      </el-tab-pane>
      <el-tab-pane label="视频资源" name="banner">
        <bannerManage v-if="activeName==='banner'" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import bannerManage from './bannerManage/index.vue';
import videoType from './videoType/index.vue';
export default {
  name: 'OriginalVideo',
  components: {
    bannerManage,
    videoType
  },
  data: () => {
    return {
      activeName: 'type'
    };
  }
};
</script>
